import { render } from "./SkillSetting.vue?vue&type=template&id=8a90f854"
import script from "./SkillSetting.vue?vue&type=script&lang=js"
export * from "./SkillSetting.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__